const selectApplyModeFromClipboardSuggestion = (state: AnyFixMe) =>
  state.applyModeFromClipboardSuggestion;

export { selectApplyModeFromClipboardSuggestion };
